var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"my-5 mx-5"},[_c('h3',[_c('span',{staticClass:"primary--text"},[_vm._v(" "+_vm._s(this.title)+": ")]),_vm._v(" "+_vm._s(this.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }